import { ConfigProvider } from 'antd'

import styleVariables from 'assets/styles/variables/variables.json'

const ThemeConfigProvider = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: styleVariables['@primary-color'],
          colorBorder: styleVariables['@border-color'],
          colorInfo: styleVariables['@info-color'],
          colorWarning: styleVariables['@warning-color'],
          colorError: styleVariables['@error-color'],
          fontFamily: styleVariables['@font-family'],
          colorInfoBorder: styleVariables['@info-border'],
          colorInfoActive: styleVariables['@info-primary'],
          colorInfoBg: styleVariables['@blue-1'],
          colorBgLayout: styleVariables['@layout-background'],
          borderRadius: styleVariables['@border-radius-base-number'],
          colorLink: styleVariables['@primary-color'],
          colorPrimaryText: styleVariables['@primary-text-color'],
          colorTextSecondary: styleVariables['@secondary-text-color'],
          lineHeight: styleVariables['@line-height-base-number'],
          colorPrimaryActive: styleVariables['@primary-color'],
          linkFocusDecoration: styleVariables['@success-border'],
          colorSuccessBorder: styleVariables['@success-border'],
          colorSuccessBg: styleVariables['@success-background'],
          fontWeightStrong: 500,
          fontSize: styleVariables['@font-size-base-number'],
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default ThemeConfigProvider
